import React, { FC } from "react";
import {
  FaAngleLeft,
  FaAngleRight,
  FaAnglesLeft,
  FaAnglesRight,
} from "react-icons/fa6";

export type PagerProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const Pager: FC<PagerProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const handleFirstPage = () => onPageChange(1);
  const handlePrevPage = () => onPageChange(currentPage - 1);
  const handleNextPage = () => onPageChange(currentPage + 1);
  const handleLastPage = () => onPageChange(totalPages);

  return (
    <div className="flex justify-between items-center my-4 mx-4">
      <div className="flex">
        <span
          onClick={currentPage === 1 ? undefined : handleFirstPage}
          className={`cursor-pointer flex items-center justify-center rounded-md font-bold px-2 mx-2 ${
            currentPage === 1 && "text-gray-300"
          }`}
        >
          <FaAnglesLeft />
        </span>
        <span
          onClick={currentPage === 1 ? undefined : handlePrevPage}
          className={`cursor-pointer flex items-center justify-center rounded-md font-bold px-2 ml-3 ${
            currentPage === 1 && "text-gray-300"
          }`}
        >
          <FaAngleLeft />
        </span>
      </div>

      <div className="grow min-w-0 grid grid-cols-5 text-lg">
        <div className="col-span-2 text-end overflow-hidden overflow-ellipsis whitespace-nowrap">
          {currentPage}
        </div>
        <div className="text-center">/</div>
        <div className="col-span-2 text-start overflow-hidden overflow-ellipsis whitespace-nowrap">
          {totalPages}
        </div>
      </div>

      <div className="flex">
        <span
          onClick={currentPage === totalPages ? undefined : handleNextPage}
          className={`cursor-pointer flex items-center justify-center rounded-md font-bold px-2 mr-3 ${
            currentPage === totalPages && "text-gray-300"
          }`}
        >
          <FaAngleRight />
        </span>
        <span
          onClick={currentPage === totalPages ? undefined : handleLastPage}
          className={`cursor-pointer flex items-center justify-center rounded-md font-bold px-2 mx-2 ${
            currentPage === totalPages && "text-gray-300"
          }`}
        >
          <FaAnglesRight />
        </span>
      </div>
    </div>
  );
};
